// Pure rules of the "Detalle" of Gestiones IPC (design Prompts 5, 6 and 7; T6). The data comes from GET gestiones/{id}
// or, for a histórico, from the queue row and GET contexto (there is no detail endpoint for legacy rows, L18).
import { codeOf, formatDate } from "../../crmpostventa-shared/crmFormat";
import { isOpenGestion } from "../ipcFormat";
import { isOpenEstado } from "../gestionar/gestionarIpcModel";

// An open gestión of the module, in an open state.
export const isAbierta = (gestion) => isOpenGestion(gestion) && isOpenEstado(gestion?.estado);

// Stage label of the header (accepted prototype addition): Abierta, Finalizada or Histórica.
export const detalleStage = (gestion) => {
  if (gestion?.esHistorico) return "Histórica";
  return isAbierta(gestion) ? "Abierta" : "Finalizada";
};

const sameHistorico = (row) => (item) => Boolean(item?.esHistorico) && Number(item.id) === Number(row?.id);

/**
 * Detail of a histórico in the shape of GET gestiones/{id}: the queue row plus the comercio data of the context (phone,
 * razón social), no timeline, no permissions, and its other gestiones (the open ones and the last closed ones of the
 * context, without itself). The cut-off date comes from the context, else from the queue.
 */
export const historicoDetalle = (row, contexto, fechaCorteHistorico = null) => {
  const cliente = contexto?.cliente || {};
  const otras = [...(contexto?.gestionesAbiertas || []), ...(contexto?.ultimasCerradas || [])].filter((item) => !sameHistorico(row)(item));
  return {
    gestion: { ...row, telefono: cliente.telefono ?? null, razonSocial: cliente.razonSocial ?? null },
    timeline: [],
    otrasGestiones: otras,
    totalOtrasGestiones: otras.length,
    puedeGestionar: false,
    puedeTomar: false,
    puedeLiberar: false,
    puedeAsignar: false,
    versionToken: "",
    fechaCorteHistorico: contexto?.fechaCorteHistorico ?? fechaCorteHistorico ?? null,
  };
};

// Observation written when the gestión was finalized: the newest FINALIZAR entry of the timeline (newest first).
export const closingObservacion = (timeline) =>
  String((timeline || []).find((entry) => codeOf(entry?.accion) === "FINALIZAR")?.observacion || "").trim() || null;

// Date of another gestión of the comercio: when it was registered while open, when it was closed otherwise.
export const otraFecha = (item) =>
  isOpenGestion(item) || !item?.fechaCierre ? `Registrada ${formatDate(item?.fechaAlta)}` : `Cerrada ${formatDate(item.fechaCierre)}`;

// "Ver todas" goes to Activas when the comercio has an open gestión (this one or another), else to Finalizadas.
export const comercioTieneAbiertas = (gestion, otras) => isAbierta(gestion) || (otras || []).some((item) => isOpenGestion(item));
